export const Split = (raw_price) => {
  let price = raw_price.toString();
  let float_splited = price.split(".");
  let z = float_splited[0];
  let f = float_splited[1];
  if (!f) {
    f = "";
  } else {
    f = "." + f;
  }
  let arr_price = z.split("");
  arr_price = arr_price.reverse();
  let new_price = [];
  let i;
  let counter = 0;
  for (i = 1; i <= arr_price.length; i++) {
    if (i % 3 === 0) {
      new_price.push(arr_price[counter]);
      if (i !== arr_price.length) {
        new_price.push(",");
      }
    } else {
      new_price.push(arr_price[counter]);
    }
    counter++;
  }
  new_price = new_price.reverse();

  return new_price.join("") + f;
};
